<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">Manage this User</strong>
      </div>
    </template>

    <div class="d-flex justify-center">
      <ReminderDialog :user="currentUser"/>
      <DeactivateDialog activator-class="ml-2" :user="currentUser" />
    </div>
  </Section>
</template>

<script>
import { Section } from '@/components/pages'
import DeactivateDialog from '../dialogs/Deactivate'
import ReminderDialog from '../dialogs/Reminder'
import { mapGetters } from 'vuex'

export default {
  name: 'UserManageSection',

  components: { DeactivateDialog, ReminderDialog, Section },

  computed: {
    ...mapGetters('users', ['currentUser']),
  },
}
</script>
